import MapSvg from './MapSvg.vue'
import MapForm from './MapForm.vue'
import MapContainer from './MapContainer.vue'
import MapStatesList from './MapStatesList.vue'
import MapStatesListItem from './MapStatesListItem.vue'

const mapComponents = [MapSvg, MapForm, MapContainer, MapStatesList, MapStatesListItem]

export default mapComponents
